import { Box, Grid2 } from '@mui/material';
import { observer } from 'mobx-react-lite';

import PageHeader from '../../features/checkout/components/PageHeader';
import PlanDetails from '../../features/checkout/components/PlanDetails';
import UserDetails from '../../features/checkout/components/UserDetails';
import useUser from '../../../shared/features/user/hooks/useUser';
import OverflowLoader from '../../../shared/components/OverflowLoader';
import useStripeSubscription from '../../features/checkout/hooks/useStripeSubscription';
import useStripePayment from '../../features/checkout/hooks/useStripePayment';
import useDidMount from '../../../shared/hooks/useDidMount';
import rootStore from '../../features/rootStore/RootStore';
import useSaveSearchParams from '../../features/uiState/hooks/useSaveSearchParams';

const Checkout = observer(() => {
  const { isSaveCustomerLoading } = useUser(rootStore);
  const { isSubscriptionSaving } = useStripeSubscription();
  const { paymentInProgress } = useStripePayment();
  const { checkoutStore, subscriptionPreviewStore } = rootStore;

  const showLoader =
    isSaveCustomerLoading || isSubscriptionSaving || paymentInProgress;

  useSaveSearchParams();

  useDidMount(() => () => {
    checkoutStore.reset();
    subscriptionPreviewStore.reset();
  });

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: {
            sm: 'none',
            md: 'no-repeat center / cover url(./assets/checkoutBackground.png)',
          },
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          width: 1,
        }}
      >
        <PageHeader />
        <Grid2
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'center', sm: 'stretch' },
            gap: 8,
          }}
        >
          <PlanDetails />
          <UserDetails />
        </Grid2>
      </Box>
      {showLoader && <OverflowLoader />}
    </>
  );
});

export default Checkout;
